export default __webpack_public_path__ + "static/media/time_green.f7dbba0f.svg";